import { MouseEvent, useCallback } from 'react';

import { NotificationListItem } from 'components/NotificationList/Item/NotificationListItem';
import {
  MappedLocalNotification,
  NotificationStatus,
  useUpdateLocalNotification,
} from 'utils/localNotifications';

type Props = {
  notification: MappedLocalNotification;
  dismissible: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
};

export function LocalNotificationListItem({
  notification,
  dismissible,
  onClick,
}: Props) {
  const updateLocalNotification = useUpdateLocalNotification();

  const handleClick = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      updateLocalNotification(notification.type, {
        read: true,
      });
      onClick?.(event);
    },
    [updateLocalNotification, notification, onClick],
  );

  const handleDismiss = useCallback(
    () =>
      updateLocalNotification(notification.type, {
        status: NotificationStatus.DISMISSED,
        read: true,
      }),
    [updateLocalNotification, notification],
  );

  return (
    <NotificationListItem
      notification={notification}
      onClick={handleClick}
      onDismiss={dismissible ? handleDismiss : undefined}
      qaId="notification"
    />
  );
}
